<template>
  <TheButton
    id="tracking_contactUs"
    type="unfilled"
    size="medium"
    hierarchy="secondary"
    :to="`/${locale}/marketplace/help/contact-us`"
    :title="$t('header.contact-us')"
  >
    <span class="text-sm font-bold">
      {{ $t('header.contact-us') }}
    </span>
  </TheButton>
</template>

<script setup lang="ts">
  const { locale } = useI18n();
</script>
